import { Download } from 'lucide-react';
import { DOC_TYPE_COLORS, fmtFileSize } from '../utils';

export function DocCard({ doc, index }) {
  const name = doc.name || doc.filename || `Document ${index + 1}`;
  const ext  = name.includes('.') ? name.split('.').pop().toUpperCase() : (doc.type?.toUpperCase() || 'DOC');
  const { bg, text } = DOC_TYPE_COLORS[ext] || { bg: 'bg-slate-100', text: 'text-slate-600' };
  const size = doc.size != null ? fmtFileSize(doc.size) : (doc.fileSize || null);

  return (
    <div className="flex items-center gap-3 bg-slate-50 border border-slate-100 rounded-xl p-3">
      <div className={`w-10 h-10 rounded-lg ${bg} flex items-center justify-center flex-shrink-0`}>
        <span className={`text-[10px] font-bold ${text}`}>{ext.slice(0, 4)}</span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-[12.5px] font-semibold text-slate-900 truncate">{name}</p>
        {size && <p className="text-[11px] text-slate-400 mt-0.5">{size}</p>}
      </div>
      {doc.url && (
        <a
          href={doc.url}
          target="_blank"
          rel="noopener noreferrer"
          className="text-slate-400 hover:text-primary flex-shrink-0 transition-colors"
        >
          <Download size={14} strokeWidth={1.75} />
        </a>
      )}
    </div>
  );
}
